import { combineReducers } from 'redux'

import search from './search'
import nextLesson from './nextLesson'

export default combineReducers({
  nextLesson,
  search,
})
